"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledParagraph = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const typography_1 = __importDefault(require("../../components/styles/typography"));
exports.StyledParagraph = styled_1.default.p `
	${typography_1.default.b1}
	word-break: break-word;
	@media only screen and (min-width: 760px) {
		.paragraph--mid {
			flex-basis: 60%;
			max-width: 60%;
		}

		.paragraph--narrow {
			flex-basis: 40%;
			max-width: 40%;
		}
}

`;
//# sourceMappingURL=Paragraph.styled.js.map